module.exports = __webpack_public_path__ + "media/images/about-us/media4-37b54cf76c5cc6496be617db41def336.jpg";